import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import Header from "../../partials/header";
import LeftSidebar from "../../partials/leftSidebar";
// import RolesTab from "./RolesTab";
import UsersTab from "./UsersTab";

const UsersMain = () => {
  const breadCrumb = [
    {
      label: "Admin",
      path: "/admin",
    },
    {
      label: "Users",
      path: "/admin/users",
    },
  ];

  const [displayRolesButton, setDisplayRolesButton] = useState(true);
  const [activeTab, setActiveTab] = useState<"users" | "roles">("users");
  const handleTabClick = (tab: "users" | "roles") => {
    setActiveTab(tab);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Header title="" breadCrumb={breadCrumb} />
      <LeftSidebar />
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          marginTop: 8,
          padding: "0",
        }}
      >
        <Box sx={{ margin: "20px", height: "100vh" }} component="main">
          <Stack>
            <Box sx={{ position: "absolute" }}>
              <Typography sx={{fontSize: "22px"}}>Users</Typography>
              {/* <Box className="tab-buttons">
                <button
                  className={
                    activeTab === "users" ? "tab-btn active" : "tab-btn"
                  }
                  onClick={() => handleTabClick("users")}
                >
                  Users
                </button>
                {displayRolesButton && (
                  <button
                    className={
                      activeTab === "roles" ? "tab-btn active" : "tab-btn"
                    }
                    onClick={() => handleTabClick("roles")}
                  >
                    Roles
                  </button>
                )}
              </Box> */}
            </Box>

            {activeTab === "users" && <UsersTab />}
            {/* {activeTab === "roles" && <RolesTab />} */}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default UsersMain;
